import type { App } from 'vue'

export default (app: App): void => {
    app.config.globalProperties.$trans = Lang
    app.config.globalProperties.$locale = Locale
    app.config.globalProperties.$languagesLinks = LanguagesLinks
    app.config.globalProperties.$auth = Auth
    app.config.globalProperties.$globalConfig = GlobalConfig
}
